module.exports = __webpack_public_path__ + "static/img/bcg_plakaty.1c16d756.png";